import { useEffect, useState } from "react";
import mime from "mime";
const useResourceType = (url) => {
    const [resourceType, setResourceType] = useState(null);
    const [isImage, setIsImage] = useState(false);
    const [isVideo, setIsVideo] = useState(false);
    const [isHtml, setIsHtml] = useState(false);
    const [isGltf, setIsGltf] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (!url)
            return;
        const checkResourceType = async () => {
            try {
                const response = await fetch(url, { method: "HEAD" });
                const contentType = response.headers.get("Content-Type");
                if (contentType) {
                    setResourceType(contentType);
                    setIsImage(contentType.startsWith("image/"));
                    setIsVideo(contentType.startsWith("video/"));
                    setIsHtml(contentType.startsWith("text/html"));
                    setIsGltf(contentType.startsWith("model/gltf"));
                }
            }
            catch (err) {
                setError(err);
                const fileType = mime.getType(url);
                if (fileType) {
                    setResourceType(fileType);
                    setIsVideo(fileType.startsWith("video/"));
                    setIsImage(fileType.startsWith("image/"));
                    setIsHtml(fileType.startsWith("text/html"));
                    setIsGltf(fileType.startsWith("model/gltf"));
                }
            }
        };
        checkResourceType();
    }, [url]);
    return { resourceType, isImage, isVideo, isHtml, isGltf, error };
};
export default useResourceType;
